var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPawHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67121 34.5206C0.770082 34.5206 3.65751 25.9012 3.65751 20C3.65751 14.0989 0.770082 5.47949 6.67121 5.47949C12.5723 5.47949 22.0137 14.3729 22.0137 20.274C22.0137 26.1751 12.5723 34.5206 6.67121 34.5206Z",
    fill: "#DFDCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65751 20C3.53231 17.5343 0.643809 14.8357 0.643809 11.5069C0.643809 8.17805 3.34237 5.47949 6.67121 5.47949C10 5.47949 12.6986 8.17805 12.6986 11.5069C12.6986 14.8357 6.98635 20 3.65751 20Z",
    fill: "#DFDCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67121 34.5206C3.34237 34.5206 0.643809 31.822 0.643809 28.4932C0.643809 25.1644 3.48176 23.0137 3.65751 20C6.98635 20 12.6986 25.1644 12.6986 28.4932C12.6986 31.822 10 34.5206 6.67121 34.5206Z",
    fill: "#DFDCE5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5068,
    cy: 13.9726,
    rx: 5.75343,
    ry: 8.49315,
    transform: "rotate(90 30.5068 13.9726)",
    fill: "#DFDCE5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5068,
    cy: 26.5753,
    rx: 5.75343,
    ry: 8.49315,
    transform: "rotate(90 30.5068 26.5753)",
    fill: "#DFDCE5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.37,
    cy: 35.3425,
    rx: 4.65753,
    ry: 6.57534,
    transform: "rotate(90 20.37 35.3425)",
    fill: "#DFDCE5"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.37,
    cy: 4.65753,
    rx: 4.65753,
    ry: 6.57534,
    transform: "rotate(90 20.37 4.65753)",
    fill: "#DFDCE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawHorizontal);
export default __webpack_public_path__ + "static/media/paw-horizontal.2b082de3a3664f73c5c0b5c72f011a7e.svg";
export { ForwardRef as ReactComponent };